import {
  List,
  Create,
  Edit,
  SimpleForm,
  TextInput,
  BooleanInput,
  TextField,
  EditButton,
  DateField,
  Filter,
  Resource,
  Show, 
  BooleanField,
  ReferenceField,
  ReferenceInput,
  SelectInput,
  Datagrid 
} from "react-admin";


const Filters = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="name" alwaysOn />
  </Filter>
);

const MaterialsCategoryList = (props) => {
  return (
    <List {...props} filters={Filters(props)}>
      <div style={{marginTop: '15px'}}>
        <Datagrid rowClick="show">
          <TextField source="name" />
          <TextField source="id" />
          <ReferenceField label="Material group" source="materialGroupId" reference="materialsGroup">
            <TextField source="name" />
          </ReferenceField>
          <BooleanField source="visibleInAppEcoCalculator" />
          <DateField source="createdAt" label="Creation date" />
          <DateField source="updatedAt" label="Update date" />
          <EditButton />
        </Datagrid>
      </div>
    </List>
  );
};

const ShowMaterialsCategory = (props) => {
  return (
    <Show {...props}>
      <SimpleForm>
        <TextField source="name" />
        <TextField source="id" />
        <ReferenceField label="Material group" source="materialGroupId" reference="materialsGroup">
          <TextField source="name" />
        </ReferenceField>
        <BooleanField source="visibleInAppEcoCalculator" />
        <DateField source="createdAt" label="Creation date" />
        <DateField source="updatedAt" label="Update date" />
      </SimpleForm>
    </Show>
  );
};

const CreateMaterialsCategory = (props) => {
  return (
    <Create {...props}>
      <SimpleForm>
        <TextInput source="name" />
        <ReferenceInput label="Material group" source="materialGroupId" reference="materialsGroup">
          <SelectInput optionText="name" />
        </ReferenceInput>
        <BooleanInput source="visibleInAppEcoCalculator" />
      </SimpleForm>
    </Create>
  );
};

const EditMaterialsCategory = (props) => {
  return (
    <Edit {...props}>
      <SimpleForm>
        <TextInput source="name" />
        <ReferenceInput label="Material group" source="materialGroupId" reference="materialsGroup">
          <SelectInput optionText="name" />
        </ReferenceInput>
        <BooleanInput source="visibleInAppEcoCalculator" />
      </SimpleForm>
    </Edit>
  );
};


const materialsCategoryResource = () => <Resource
  name="materialsCategory"
  options={{ label: 'Material category', menuGroup: 'Bcome'}}
  list={MaterialsCategoryList}
  create={CreateMaterialsCategory}
  edit={EditMaterialsCategory}
  show={ShowMaterialsCategory} />;

export default materialsCategoryResource;
